import React from 'react';
import { IInvoiceRecipient } from '../../../../InvoiceCreation/types/types';
import { usePhoneFormatter } from '../../../../../../helpers/usePhoneFormatter';

export const phoneTemplate = (recipient: IInvoiceRecipient) => {
  const formattedPhoneValue = usePhoneFormatter({ value: recipient.phone ?? '' });

  return (
    <div className='flex items-center'>
      <span className='font-metricR text-[16px] text-bw08'>{formattedPhoneValue || '-'}</span>
    </div>
  );
};
